import { render } from "./AddTransfertMag.vue?vue&type=template&id=1ebd9020&scoped=true&ts=true"
import script from "./AddTransfertMag.vue?vue&type=script&lang=ts"
export * from "./AddTransfertMag.vue?vue&type=script&lang=ts"

import "./AddTransfertMag.vue?vue&type=style&index=0&id=1ebd9020&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebd9020"]])

export default __exports__